import React, { useContext, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { deleteProductLog } from '../../clients/product_client';
import { showToast } from '../../config_and_helpers/helpers';
import { logInfo, logWarn } from '../../config_and_helpers/logger';
import { AppContext } from '../../App';
import { useIsLabViewer } from '../../hooks/useIsLabViewer';
import OrderDetailModal from '../Order/OrderDetailModal';
import { resolveProductLogDeleteQuery } from '../../utils/productLogDelete';

const LOG_CONTEXT = 'StockItemLogRow';

/**
 * One row in the product stock-item logs table, including delete.
 *
 * @param {Object} props
 * @param {Object} props.log
 * @param {function} props.onSuccessfulDelete
 */
const StockItemLogRow = ({ log, onSuccessfulDelete }) => {
  const { token } = useContext(AppContext);
  const isViewer = useIsLabViewer();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const trashIcon = (
    <i className="fa fa-solid fa-trash" style={{ color: 'red' }}></i>
  );

  const handleDelete = () => {
    const resolved = resolveProductLogDeleteQuery(log);
    if (resolved.error) {
      logWarn(LOG_CONTEXT, 'delete aborted: missing id', {
        logId: log?.id ?? null,
        stockItemId: log?.stock_item_id ?? null,
        error: resolved.error,
      });
      showToast(
        'Cannot delete this log because it has no id.',
        'error',
        'top-right',
        3000,
      );
      return;
    }

    setIsSubmitting(true);
    logInfo(LOG_CONTEXT, 'delete product log', resolved.params);
    deleteProductLog(token, resolved.params).then(response => {
      if (response && response.success) {
        setTimeout(() => {
          onSuccessfulDelete(log.id);
          response.toast();
          setIsSubmitting(false);
        }, 1000);
      } else {
        showToast(
          response?.errorMessage ||
            'An unexpected error occurred. Please try again in a little while.',
          'error',
          'top-right',
          3000,
        );
        setIsSubmitting(false);
      }
    });
  };

  return (
    <tr className="text-center align-middle">
      <td>{log.batch ? log.batch : 'N/A'}</td>
      <td>{log.expiry ? log.expiry : 'N/A'}</td>
      <td>{log.person_name ? log.person_name : 'N/A'}</td>
      <td>{log.date_of_opening ? log.date_of_opening : 'N/A'}</td>
      <td>
        {log.order_id ?? log.order?.id ? (
          <OrderDetailModal orderId={log.order_id ?? log.order?.id} />
        ) : (
          'N/A'
        )}
      </td>
      {!isViewer ? (
      <td>
        {isSubmitting ? (
          <Spinner
            size="sm"
            as="span"
            animation="border"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <Button variant="" size="sm" onClick={handleDelete}>
            {trashIcon}
          </Button>
        )}
      </td>
      ) : null}
    </tr>
  );
};

export default StockItemLogRow;
